<template lang="">
    <div>
        <div id="pagebody" class="siteStyle pageStyle container-fluid    pagebody_nav pagebody_nav_1"
            style="padding-bottom: 0px;">

            <div id="BodyMainZoneContainer" class="BodyMainZoneContainer">



                <div id="Header_zhanwei">
                    <div id="HeaderZone" ismodulecontainer="true"
                    class="HeaderContainer HeaderZoneContainer ZoneContainer HeaderZone ModuleContainer clearfix ">



                    <div class="ModuleItem  StaticModule  " wo="1358" id="module_63140898">

                        <div class="ModuleSlideV2Giant layout-101 layout-color-black module_63140898 clearfix">



                            <div class="BodyCenter BodyCenter63140898 clearfix">

                                <!-- 轮播 -->

                                <div class="slider-layout-box slider-layout-103 module-slide-container slick-initialized slick-slider"
                                    is-exist-module="false">
                                    <div class="slick-list draggable">
                                        <div class="slick-track" style="opacity: 1; ">
                                            <div class="slick-slide slick-current slick-active" data-slick-index="0"
                                                aria-hidden="false"
                                                style="position: relative; left: 0px; top: 0px; z-index: 999; opacity: 1;">
                                                <div>
                                                    <div class="" style="width: 100%; display: inline-block;">
   
                                                            <div class="slide-box" v-if="bannerList.length>0">
                                                                <img class="swiperImg"
                                                                    :src="bannerList[0].pic"
                                                                    alt="联系我们" title="联系我们" delay-inited="true"
                                                                    style="background: none;">
                                                            </div>


                                                        <div id="Sub62412474_6" ismodulecontainer="true"
                                                            class="ModuleContainer SubContainer ModuleSlideContainer module_62412474"
                                                            module-container-type="ModuleSlide" a-link-value=""
                                                            a-link-target="_self">

                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>



                    </div>


                </div>
                </div>



                <div id="BodyMain1Zone" ismodulecontainer="true"
                    class="BodyContainer BodyZoneContainer ZoneContainer ModuleContainer BodyMain1Zone clearfix ">

                    <div class="ModuleItem  StaticModule  " wo="1358" id="module_63738047" style="height: auto;">

                        <div class="ModuleGridGiant layout-101 layout-color- module_63738047 clearfix">

                            <!-- 主体 -->

                            <div class="BodyCenter BodyCenter63738047 clearfix">

                                <div class="ModuleGridContainer  ModuleGridContainer63738047" gridswidthmode="2">

                                    <div class="row ModuleSubContainer">

                                        <div class="gridBgVideo noBgVideo">

                                            <video src="" class="bgVideo" autoplay="" loop=""></video>

                                            <div class="bgVideoMask"></div>

                                        </div>

                                        <div id="Sub63736911_1"
                                            class="ModuleContainer SubContainer ModuleGridItem     col-xs-12 col-sm-12 col-md-12 col-lg-12"
                                            positiontype="2" ismodulecontainer="true">

                                            <div class="ModuleItem  StaticModule  " wo="1200" id="module_63736915">

                                                <div
                                                    class="ModuleBreadcrumbsGiant layout-101 layout-color- module_63736915 clearfix">

                                                    <!-- 主体 -->

                                                    <div class="BodyCenter BodyCenter63736915 clearfix">

                                                        <ol class="breadcrumb">

                                                            <li><a class="menu bcs-item" href="https://wq01.com/">首页</a>
                                                            </li>

                                                            <li><span class="separator">&gt;</span></li>

                                                            <li><router-link class="menu bcs-item"
                                                                to="/contact/maps">联系我们</router-link>

                                                            </li>

                                                            <li><span class="separator">&gt;</span></li>

                                                            <li class="lastMenu bcs-item">联系我们</li>

                                                        </ol>

                                                    </div>

                                                </div>



                                            </div>

                                        </div>

                                        <div class="clearfix visible-lg"></div>

                                        <div class="clearfix visible-xs"></div>

                                    </div>

                                </div>

                            </div>

                        </div>



                    </div>

                    <div class="ModuleItem  StaticModule  " wo="1358" id="module_63738967" style="height: auto;">

                        <div class="ModuleGridGiant layout-101 layout-color- module_63738967 clearfix">

                            <!-- 主体 -->

                            <div class="BodyCenter BodyCenter63738967 clearfix">

                                <div class="ModuleGridContainer  ModuleGridContainer63738967" gridswidthmode="2">

                                    <div class="row ModuleSubContainer">

                                        <div class="gridBgVideo noBgVideo">

                                            <video src="" class="bgVideo" autoplay="" loop=""></video>

                                            <div class="bgVideoMask"></div>

                                        </div>

                                        <leftNav />

                                        <div class="clearfix visible-xs"></div>

                                        <div id="Sub63737119_2"
                                            class="ModuleContainer SubContainer ModuleGridItem     col-xs-12 col-sm-10 col-md-10 col-lg-10"
                                            positiontype="2" ismodulecontainer="true">

                                            <div class="ModuleItem  StaticModule  " wo="1000" id="module_63739270">

                                                <div class="ModuleImageTextGiant layout-101 layout-color-orange module_63739270 clearfix"
                                                    style="transform: translate3d(0px, 0px, 0px);">

                                                    <!-- 主体标题 -->

                                                    <div class="BodyCenter BodyCenter63739270 clearfix">

                                                        <div class="imageTextGiant-Container imageTextContainer clearfix"
                                                            hasresponsive="1" autohide="0" hideheight="150"
                                                            hidewidth="760">

                                                            <div
                                                                class="ModuleImageTextGiantContent ModuleImageTextContent">

                                                                <div style="font-family:微软雅黑;">

                                                                    <div></div>

                                                                    <p style="text-align: center;"><span
                                                                            style="font-size: 24px; line-height: 150%;">-
                                                                            联系我们 -</span></p>

                                                                    <p style="text-align: center;"><span
                                                                            style="font-size: 16px; color: rgb(153, 153, 153); line-height: 150%;">contact
                                                                            us</span>

                                                                    </p>
                                                                </div>

                                                            </div>

                                                        </div>

                                                    </div>

                                                </div>



                                            </div>

                                            <div class="ModuleItem  StaticModule  " wo="1000" id="module_63739425">

                                                <div
                                                    class="ModulePlainTextGiant layout-101 layout-color- module_63739425 clearfix">

                                                    <!-- 主体 -->

                                                    <div class="BodyCenter BodyCenter63739425 clearfix">

                                                        <div class="plainTextGiant-Container imageTextContainer clearfix"
                                                            hasresponsive="1" hidewidth="760">

                                                            <div
                                                                class="ModulePlainTextGiantContent ModuleImageTextContent">

                                                                <p style="line-height: 2em;"><span
                                                                        style="color:#333333;"><strong><span
                                                                                style="font-size:20px;"><span
                                                                                    style="line-height:1.75;">伟企集团
                                                                                    wq01.com</span></span></strong></span>

                                                                </p>



                                                                <p style="line-height: 2em;"><span
                                                                        style="color:#333333;"><span
                                                                            style="line-height:1.75;"><span
                                                                                style="font-size: 18px; line-height: 175%;">地址：佛山市禅城区三友南路17号泛家居创意园1号楼
                                                                            </span></span></span>

                                                                </p>



                                                                <p style="line-height: 2em;"><span
                                                                        style="color:#333333;"><span
                                                                            style="line-height:1.75;"><span
                                                                                style="font-size: 18px; line-height: 175%;">邮箱：vip@wq01.com
                                                                            </span></span></span>

                                                                </p>



                                                                <p style="line-height: 2em;"><span
                                                                        style="color:#333333;"><span
                                                                            style="line-height:1.75;"><span
                                                                                style="font-size: 18px; line-height: 175%;">总机：400-800-4949
                                                                            </span></span></span>

                                                                </p>



                                                                <p style="line-height: 2em;"><span
                                                                        style="color:#333333;"><span
                                                                            style="line-height:1.75;"><span
                                                                                style="font-size: 18px; line-height: 175%;">电话：0757-8361
                                                                                1111 、 8361 8888</span></span></span>

                                                                </p>



                                                            </div>

                                                        </div>

                                                    </div>

                                                </div>



                                            </div>



                                            <!--分部的联系电话-->


                                            <div class="ModuleItem  StaticModule  " wo="1000" id="module_66217366">

                                                <div
                                                    class="ModulePlainTextGiant layout-101 layout-color- module_66217366 clearfix">

                                                    <!-- 主体 -->

                                                    <div class="BodyCenter BodyCenter66217366 clearfix">

                                                        <div class="plainTextGiant-Container imageTextContainer clearfix"
                                                            hasresponsive="1" hidewidth="760">

                                                            <div
                                                                class="ModulePlainTextGiantContent ModuleImageTextContent">

                                                                <p><span style="font-size:20px;"><span
                                                                            style="line-height:1.75;"><strong>广东创业小鸟信息技术有限公司</strong></span></span><br>

                                                                    <span style="font-size:18px;"><span
                                                                            style="line-height: 175%; font-size: 18px; height: 51px;">地址：佛山市禅城区三友南路17号泛家居创意园1号楼首层<br>电话：0757-8361
                                                                            1111</span></span>

                                                                </p>



                                                            </div>

                                                        </div>

                                                    </div>

                                                </div>



                                            </div>



                                            <div class="ModuleItem  StaticModule  " wo="1000" id="module_66217951">

                                                <div
                                                    class="ModulePlainTextGiant layout-101 layout-color- module_66217951 clearfix">

                                                    <!-- 主体 -->

                                                    <div class="BodyCenter BodyCenter66217951 clearfix">

                                                        <div class="plainTextGiant-Container imageTextContainer clearfix"
                                                            hasresponsive="1" hidewidth="760">

                                                            <div
                                                                class="ModulePlainTextGiantContent ModuleImageTextContent">

                                                                <p><span style="font-size:20px;"><strong><span
                                                                                style="line-height: 175%; font-size: 20px;">广东舞金网络科技有限公司</span></strong></span>

                                                                </p>



                                                                <p><span style="line-height:1.75;"><span
                                                                            style="font-size: 18px; line-height: 175%; height:51px">地址：佛山市禅城区季华五路55号万科金融中心A座10楼</span></span>

                                                                </p>



                                                                <p><span style="line-height:1.75;"><span
                                                                            style="font-size: 18px; line-height: 175%;">电话：0757-8361
                                                                            8888</span></span>

                                                                </p>



                                                            </div>

                                                        </div>

                                                    </div>

                                                </div>



                                            </div>



                                            <div class="ModuleItem  StaticModule  " wo="1000" id="module_66217366">

                                                <div
                                                    class="ModulePlainTextGiant layout-101 layout-color- module_66217366 clearfix">

                                                    <!-- 主体 -->

                                                    <div class="BodyCenter BodyCenter66217366 clearfix">

                                                        <div class="plainTextGiant-Container imageTextContainer clearfix"
                                                            hasresponsive="1" hidewidth="760">

                                                            <div
                                                                class="ModulePlainTextGiantContent ModuleImageTextContent">

                                                                <p><span style="font-size:20px;"><span
                                                                            style="line-height:1.75;"><strong>佛山市创鸟企业孵化器有限公司</strong></span></span><br>

                                                                    <span style="font-size:18px;"><span
                                                                            style="line-height: 175%; font-size: 18px; height: 51px;">地址：佛山市禅城区汾江北路32号金谷国际交易中心二层<br>电话：0757-82228584</span></span>

                                                                </p>



                                                            </div>

                                                        </div>

                                                    </div>

                                                </div>



                                            </div>



                                            <div class="ModuleItem  StaticModule  " wo="1000" id="module_66217951">

                                                <div
                                                    class="ModulePlainTextGiant layout-101 layout-color- module_66217951 clearfix">

                                                    <!-- 主体 -->

                                                    <div class="BodyCenter BodyCenter66217951 clearfix">

                                                        <div class="plainTextGiant-Container imageTextContainer clearfix"
                                                            hasresponsive="1" hidewidth="760">

                                                            <div
                                                                class="ModulePlainTextGiantContent ModuleImageTextContent">

                                                                <p><span style="font-size:20px;"><strong><span
                                                                                style="line-height: 175%; font-size: 20px;">广东数字园叮科技有限公司</span></strong></span>

                                                                </p>



                                                                <p><span style="line-height:1.75;"><span
                                                                            style="font-size: 18px; line-height: 175%; height:51px">地址：佛山市顺德区陈村镇赤花社区广隆工业区兴业三路2号风北二层</span></span>

                                                                </p>



                                                                <p><span style="line-height:1.75;"><span
                                                                            style="font-size: 18px; line-height: 175%;">电话：0757-8222
                                                                            1561</span></span>

                                                                </p>



                                                            </div>

                                                        </div>

                                                    </div>

                                                </div>



                                            </div>



                                            <div class="ModuleItem  StaticModule  " wo="1000" id="module_66217366">

                                                <div
                                                    class="ModulePlainTextGiant layout-101 layout-color- module_66217366 clearfix">

                                                    <!-- 主体 -->

                                                    <div class="BodyCenter BodyCenter66217366 clearfix">

                                                        <div class="plainTextGiant-Container imageTextContainer clearfix"
                                                            hasresponsive="1" hidewidth="760">

                                                            <div
                                                                class="ModulePlainTextGiantContent ModuleImageTextContent">

                                                                <p><span style="font-size:20px;"><span
                                                                            style="line-height:1.75;"><strong>佛山数字园叮技术有限公司</strong></span></span><br>

                                                                    <span style="font-size:18px;"><span
                                                                            style="line-height: 175%; font-size: 18px; height: 51px;">地址：佛山市顺德区大良街道凤翔路41号顺德创意产业园D栋204号<br>电话：0757-83333350</span></span>

                                                                </p>



                                                            </div>

                                                        </div>

                                                    </div>

                                                </div>



                                            </div>



                                            <div class="ModuleItem  StaticModule  " wo="1000" id="module_66217951">

                                                <div
                                                    class="ModulePlainTextGiant layout-101 layout-color- module_66217951 clearfix">

                                                    <!-- 主体 -->

                                                    <div class="BodyCenter BodyCenter66217951 clearfix">

                                                        <div class="plainTextGiant-Container imageTextContainer clearfix"
                                                            hasresponsive="1" hidewidth="760">

                                                            <div
                                                                class="ModulePlainTextGiantContent ModuleImageTextContent">

                                                                <p><span style="font-size:20px;"><strong><span
                                                                                style="line-height: 175%; font-size: 20px;">佛山顺德租租侠科技孵化器有限公司</span></strong></span>

                                                                </p>



                                                                <p><span style="line-height:1.75;"><span
                                                                            style="font-size: 18px; line-height: 175%; height:51px">地址：佛山市顺德区陈村镇赤花社区广隆工业园兴业4路顺联机械城第25座二层232-234、陈村聚福广场四楼403-405</span></span>

                                                                </p>



                                                                <p><span style="line-height:1.75;"><span
                                                                            style="font-size: 18px; line-height: 175%;">电话：0757-82222223</span></span>

                                                                </p>



                                                            </div>

                                                        </div>

                                                    </div>

                                                </div>



                                            </div>



                                            <div class="ModuleItem  StaticModule  " wo="1000" id="module_66217366">

                                                <div
                                                    class="ModulePlainTextGiant layout-101 layout-color- module_66217366 clearfix">

                                                    <!-- 主体 -->

                                                    <div class="BodyCenter BodyCenter66217366 clearfix">

                                                        <div class="plainTextGiant-Container imageTextContainer clearfix"
                                                            hasresponsive="1" hidewidth="760">

                                                            <div
                                                                class="ModulePlainTextGiantContent ModuleImageTextContent">

                                                                <p><span style="font-size:20px;"><span
                                                                            style="line-height:1.75;"><strong>佛山租租侠投资服务有限公司</strong></span></span><br>

                                                                    <span style="font-size:18px;"><span
                                                                            style="line-height: 175%; font-size: 18px; height: 51px;">地址：佛山市南海区桂城街道季华东路31号天安中心12座820室<br>电话：0757-87675777</span></span>

                                                                </p>



                                                            </div>

                                                        </div>

                                                    </div>

                                                </div>



                                            </div>



                                            <div class="ModuleItem  StaticModule  " wo="1000" id="module_66217951">

                                                <div
                                                    class="ModulePlainTextGiant layout-101 layout-color- module_66217951 clearfix">

                                                    <!-- 主体 -->

                                                    <div class="BodyCenter BodyCenter66217951 clearfix">

                                                        <div class="plainTextGiant-Container imageTextContainer clearfix"
                                                            hasresponsive="1" hidewidth="760">

                                                            <div
                                                                class="ModulePlainTextGiantContent ModuleImageTextContent">

                                                                <p><span style="font-size:20px;"><strong><span
                                                                                style="line-height: 175%; font-size: 20px;">佛山数字园叮网络有限公司</span></strong></span>

                                                                </p>



                                                                <p><span style="line-height:1.75;"><span
                                                                            style="font-size: 18px; line-height: 175%; height:51px">地址：佛山市南海区大沥镇岭南路77号百鸿大厦1806-1807房</span></span>

                                                                </p>



                                                                <p><span style="line-height:1.75;"><span
                                                                            style="font-size: 18px; line-height: 175%;">电话：18934399995</span></span>

                                                                </p>



                                                            </div>

                                                        </div>

                                                    </div>

                                                </div>



                                            </div>



                                            <div class="ModuleItem  StaticModule  " wo="1000" id="module_66217366">

                                                <div
                                                    class="ModulePlainTextGiant layout-101 layout-color- module_66217366 clearfix">

                                                    <!-- 主体 -->

                                                    <div class="BodyCenter BodyCenter66217366 clearfix">

                                                        <div class="plainTextGiant-Container imageTextContainer clearfix"
                                                            hasresponsive="1" hidewidth="760">

                                                            <div
                                                                class="ModulePlainTextGiantContent ModuleImageTextContent">

                                                                <p><span style="font-size:20px;"><span
                                                                            style="line-height:1.75;"><strong>佛山禅城租租侠企业孵化器有限公司</strong></span></span><br>

                                                                    <span style="font-size:18px;"><span
                                                                            style="line-height: 175%; font-size: 18px; height: 51px;">地址：佛山市禅城区季华五路10号金融广场十六层<br>电话：18934388881</span></span>

                                                                </p>



                                                            </div>

                                                        </div>

                                                    </div>

                                                </div>



                                            </div>



                                            <div class="ModuleItem  StaticModule  " wo="1000" id="module_66204194">

                                                <div
                                                    class="ModuleButtonGiant layout-105 layout-color-red module_66204194 clearfix">

                                                    <!-- 主体 -->

                                                    <div class="BodyCenter BodyCenter66204194 clearfix"><a
                                                            href="https://work.weixin.qq.com/kfid/kfc982e9ffca5d1e11e"
                                                            target="_blank" class="moduleButton Shutter-Out-Horizontal">

                                                            <div class="buttonbox">

                                                                <span class="ButtonText">在线咨询</span>

                                                            </div>

                                                        </a>

                                                    </div>

                                                </div>



                                            </div>

                                            <div class="ModuleItem  StaticModule  " wo="1000" id="module_66215343">

                                                <div
                                                    class="ModuleButtonGiant layout-105 layout-color-red module_66215343 clearfix">

                                                    <!-- 主体 -->

                                                    <div class="BodyCenter BodyCenter66215343 clearfix">
                                                        <router-link to="/contact/feedback" class="moduleButton Shutter-Out-Horizontal">
                                                            <div class="buttonbox">
                                                                <span class="ButtonText">在线留言</span>
                                                            </div>
                                                        </router-link>

                                                    </div>

                                                </div>



                                            </div>

                                            <!--TODO:地图暂时隐藏-->

                                            <!--                                    <div class="ModuleItem  StaticModule  " wo="1000" id="module_63737152">-->

                                            <!--                                        <div class="ModuleMapGiant layout-101 layout-color- module_63737152 clearfix">-->

                                            <!--                                            &lt;!&ndash; 主体 &ndash;&gt;-->

                                            <!--                                            <div class="BodyCenter BodyCenter63737152 clearfix">-->

                                            <!--                                                <div class="mapgiant-container">-->

                                            <!--                                                    <div class="searchLayout">-->

                                            <!--                                                        <div class="vehicleTab">-->

                                            <!--                                                            <p class="navBtn active"><i class="iconfont icon-jiache"></i><span>驾车</span></p>-->

                                            <!--                                                            <p class="busBtn"><i class="iconfont icon-gongjiao"></i><span>公交</span></p>-->

                                            <!--                                                        </div>-->

                                            <!--                                                        <div class="keywordBox">-->

                                            <!--                                                            <p class="fromKeywordLabel">-->

                                            <!--                                                                <span></span>-->

                                            <!--                                                                <input type="text" class="fromKeyword" value="" placeholder="请输入起点" />-->

                                            <!--                                                            </p>-->

                                            <!--                                                            <button class="searchBtn" data-type="navBtn"><i class="iconfont icon-sousuo2"></i></button>-->

                                            <!--                                                        </div>-->

                                            <!--                                                    </div>-->

                                            <!--                                                    <div id="mapContainer63737152" class="mapContainer"-->

                                            <!--                                                         data-title="<div style=width:120px>伟企集团 wq01.com</div>"-->

                                            <!--                                                         data-lat="22.518691882884728" data-long="113.41916084289551">-->

                                            <!--                                                    </div>-->

                                            <!--                                                    <script type="text/javascript">-->

                                            <!--                                                        addScript('/public/js/ModuleMap.js', function () {-->

                                            <!--                                                            var funType = 'addQQMap';-->

                                            <!--                                                            if ("1" == "1") funType = 'addBaiduMap';-->

                                            <!--                                                            else if ("1" == "2") funType = 'addGoogleMap';-->



                                            <!--                                                            window[funType] = function (flag) {-->

                                            <!--                                                                if (window[funType + 'ScriptArray'] && !flag){-->

                                            <!--                                                                    window[funType + 'ScriptArrayFlag'] = true-->

                                            <!--                                                                    window[funType + 'ScriptArray'].forEach(function(func) {-->

                                            <!--                                                                        func(true)-->

                                            <!--                                                                    })-->

                                            <!--                                                                    window[funType + 'ScriptArray'] = null-->

                                            <!--                                                                    return-->

                                            <!--                                                                }-->

                                            <!--                                                                var opiton = {-->

                                            <!--                                                                    Latitude: '22.518691882884728',-->

                                            <!--                                                                    Longitude: '113.41916084289551',-->

                                            <!--                                                                    ItemTitle: "<div style=width:120px>伟企集团 wq01.com</div>",-->

                                            <!--                                                                    MapType: "1",-->

                                            <!--                                                                    Sliding: "0",-->

                                            <!--                                                                    ShowType: "1",-->

                                            <!--                                                                    Zoom: Number("18")-->

                                            <!--                                                                }-->

                                            <!--                                                                if ("1" == "1") initBaiDuMap('63737152', "101", opiton);-->

                                            <!--                                                                else if ("1" == "2") ;-->

                                            <!--                                                                else initQQMap('63737152', "101", opiton);-->



                                            <!--                                                                isSliding('63737152', opiton);-->

                                            <!--                                                            }-->

                                            <!--                                                            if (window[funType + 'ScriptArrayFlag']) {-->

                                            <!--                                                                window[funType]()-->

                                            <!--                                                            } else {-->

                                            <!--                                                                window[funType + 'ScriptArray'] = window[funType + 'ScriptArray'] ? window[funType + 'ScriptArray']: []-->

                                            <!--                                                                window[funType + 'ScriptArray'].push(window[funType])-->

                                            <!--                                                            }-->

                                            <!--                                                            if ("1" == "1") {-->

                                            <!--                                                                addScript('//api.map.baidu.com/api?v=3.0&callback=' + funType + '&ak=', function() {});-->

                                            <!--                                                            } else if ("1" == "2") {-->

                                            <!--                                                                loadStyleSheet('https://unpkg.com/leaflet@1.7.1/dist/leaflet.css');-->

                                            <!--                                                                addScript('/public/js/ModuleMap.js', function () {-->

                                            <!--                                                                    addScript('https://unpkg.com/leaflet@1.7.1/dist/leaflet.js',function(){-->

                                            <!--                                                                        var option = {-->

                                            <!--                                                                            Latitude: '22.518691882884728',-->

                                            <!--                                                                            Longitude: '113.41916084289551',-->

                                            <!--                                                                            ItemTitle: "<div style=width:120px>伟企集团 wq01.com</div>",-->

                                            <!--                                                                            MapType: "1",-->

                                            <!--                                                                            ShowType: "1",-->

                                            <!--                                                                            Sliding: "0",-->

                                            <!--                                                                            Zoom: Number("18")-->

                                            <!--                                                                        }-->

                                            <!--                                                                        initGoogleMapWithLeaflet('63737152',option);-->



                                            <!--                                                                        isSliding('63737152', option);-->



                                            <!--                                                                    });-->

                                            <!--                                                                });-->

                                            <!--                                                            } else {-->

                                            <!--                                                                addScript('https://map.qq.com/api/js?v=2.exp&callback=' + funType + '&key=', function() {});-->

                                            <!--                                                            }-->

                                            <!--                                                        });-->

                                            <!--                                                    </script>-->

                                            <!--                                                </div>-->

                                            <!--                                            </div>-->

                                            <!--                                        </div>-->



                                            <!--                                    </div>-->

                                        </div>

                                        <div class="clearfix visible-lg"></div>

                                        <div class="clearfix visible-xs"></div>

                                    </div>

                                </div>

                            </div>

                        </div>



                    </div>

                </div>


            </div>

        </div>
    </div>
</template>
<script>
    import leftNav from '@/components/leftnav'
    export default {
        components: {
            leftNav
        },
        data() {
            return {
                mapsList: [],
                zongList: [],
                bannerList: []
            }
        },
        created() {
            this.getMaps()
            this.getBanner()
            document.title='联系我们-伟企集团 - 数智化一站式企服平台'
        },
        methods: {
            async getMaps() {
                let res = await this.$request.post('contact/getAll')
                if (res.data.code === 0) {
                    this.mapsList = res.data.data
                }
            },
            async getBanner() {
                let res = await this.$request.post('aboutbanner/getAll')
                if (res.data.code === 0) {
                    this.bannerList = res.data.data
                    this.bannerList = this.bannerList.filter(item => item.title === '联系我们')
                }
            }
        },
    }
</script>
<style lang="">

</style>